import type { ParamMatcher } from "@sveltejs/kit";

// TODO update with more reserved names
const RESERVED_USERNAMES = ["docs", "apps", "logs", "secrets", "storage"];

export const match: ParamMatcher = (param) => {
  return !RESERVED_USERNAMES.includes(param);
};
